import {Injectable} from '@angular/core';
import {Observable} from '../../../../../node_modules/rxjs';
import {Http} from '@angular/http';

@Injectable()
export class NpiService {

    private readonly baseUrl: string;

    constructor(readonly http: Http) {
        this.baseUrl = `${process.env.NPI_SERVICE_BASE_URI}/search`;
    }

    search<Npi>(npiNumber?: string): Observable<Npi> {
        return this.http.get(`${this.baseUrl}?npi=${npiNumber}`).map(res => {
            return res.text().length ? res.json() : undefined;
        });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/npi/npi.service.ts